import * as m from "react-parallax";
export const Parallax = m.Parallax;
export const Background = m.Background;
